import React from 'react';

import EditorFormik from '~/components/communications/EmailCommunicationCard/EmailEditor/EditorFormik';
import Text from '~/components/core/TextComponents/Text';
import type { TemplateBuilderEditorInnerComponentProps } from '~/components/GenericTemplates/types';
import { TEMPLATE_BUILDER_FORM_KEYS } from '~/components/GenericTemplates/utils/genericTemplatesUtils';

const SmsGenericTemplatesEditorFormik: React.FC<TemplateBuilderEditorInnerComponentProps> = ({
  disabled,
  suggestions,
}) => {
  return (
    <div className="my-32">
      <Text variant={Text.VARIANTS.SM} className="my-12">
        SMS Body
      </Text>
      <EditorFormik
        id={TEMPLATE_BUILDER_FORM_KEYS.BODY_TEMPLATE}
        classNameEditor="overflow-auto"
        disabled={disabled}
        autoFocus
        displayConfig={{ suggestions: !!suggestions }}
        suggestionOptions={suggestions}
      />
    </div>
  );
};

export default SmsGenericTemplatesEditorFormik;
